import React from 'react';
import { Tag } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

export default function AdminProgramCategories() {
  return (
    <AdminCRUD
      endpoint="program-categories"
      title="Program Categories"
      icon={Tag}
      columns={[
        { key: 'name', label: 'Category', render: (v, item) => (
          <div className="flex items-center gap-3">
            {item.image
              ? <img src={item.image} alt={v} className="w-9 h-9 rounded-lg object-cover flex-shrink-0" />
              : <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-royal-700 to-royal-900 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">{v?.[0]}</div>}
            <div>
              <div className="font-semibold text-gray-900 text-sm">{v}</div>
              <span className="text-[11px] text-gray-400">{item.slug}</span>
            </div>
          </div>
        )},
        { key: 'order', label: 'Order', render: v => <span className="text-sm text-gray-500">{v ?? 0}</span> },
        { key: 'isActive', label: 'Active', render: v => v ? <span className="text-emerald-500 font-bold">✓</span> : <span className="text-gray-300">—</span> },
      ]}
      defaultForm={{ name: '', slug: '', description: '', icon: '', image: '', isActive: true, order: 0 }}
      formFields={[
        { key: 'image', label: 'Category Image', type: 'image', fullWidth: true },
        { key: 'name', label: 'Category Name', required: true },
        { key: 'slug', label: 'Slug (auto-generated if left blank)' },
        { key: 'icon', label: 'Icon (optional identifier)' },
        { key: 'order', label: 'Display Order', type: 'number' },
        { key: 'description', label: 'Description', type: 'textarea', fullWidth: true, rows: 3 },
        { key: 'isActive', label: 'Active', type: 'checkbox', checkLabel: 'Show in public filters', fullWidth: true },
      ]}
    />
  );
}